/**
 * 对话状态常量
 */

/**
 * 对话状态枚举
 */
export const CONVERSATION_STATUS = {
  /** 等待主诉 */
  WAITING_COMPLAINT: 'waiting_chief_complaint',
  /** 收集基础信息 */
  COLLECTING_INFO: 'collecting_basic_info',
  /** 已完成 */
  COMPLETED: 'completed'
}

/**
 * 二维码类型
 */
export const QR_CODE_TYPES = {
  /** 问卷二维码 */
  QUESTIONNAIRE: 'questionnaire',
  /** 主诉二维码 */
  CHIEF_COMPLAINT: 'chief_complaint'
}

/**
 * 消息类型
 */
export const MESSAGE_TYPES = {
  TEXT: 'text',
  AUDIO: 'audio'
}

/**
 * 消息发送者
 */
export const MESSAGE_SENDER = {
  AI: 'ai',
  USER: 'user'
}

